import React from 'react'
import { withTranslation } from "react-i18next";
import { tablestyle } from '../../utils'
import { withStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);


function CustomTooltip(props) {
    const { title = '', placement = 'right', children } = props
    return (
        <LightTooltip title={title} placement={placement}>
            {children && children[1] || children}
        </LightTooltip>
    )
}

export default withTranslation("translations")(withStyles(tablestyle)(CustomTooltip));
